import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from 'utils/axios';

export const getAllOneDayBooking = createAsyncThunk(
  'oneDayBooking/getAllOneDayBooking',
  async ({ limit = 10, page = 1 }, thunkAPI) => {
    try {
      const response = await axiosInstance.get(`/one-day-booking-surcharges?limit=${limit}&page=${page}`);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);

export const getDetailOneDayBooking = createAsyncThunk('oneDayBooking/getDetailOneDayBooking', async (id, thunkAPI) => {
  let newUrl = `/one-day-booking-surcharges/${id}`;

  try {
    const response = await axiosInstance.get(newUrl);

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const createOneDayBooking = createAsyncThunk('oneDayBooking/createoneDayBooking', async (payload, thunkAPI) => {
  try {
    const response = await axiosInstance.post(
      `/one-day-booking-surcharges`,
      { ...payload },
      {
        headers: {
          'Content-Type': 'application/json;charset=utf-8',
        },
      },
    );

    const data = await response.data;
    return data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const deleteOneDayBooking = createAsyncThunk('oneDayBooking/deleteOneDayBooking', async (id, thunkAPI) => {
  try {
    const response = await axiosInstance.delete(`/one-day-booking-surcharges/${id}`);

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

// // UPDATE ADDON
export const updateOneDayBooking = createAsyncThunk('oneDayBooking/updateOneDayBooking', async (payload, thunkAPI) => {
  const { payloadData, id } = payload;

  try {
    const response = await axiosInstance.put(
      `/one-day-booking-surcharges/${id}`,
      { ...payloadData },
      {
        headers: {
          'Content-Type': 'application/json;charset=utf-8',
        },
      },
    );

    const data = await response.data;
    return data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});
